import {mapGetters} from 'vuex'
import store from '@/common/vuex/store_rt'

export default {
  name: 'MwView',
  props: {
    params: {
      type: Object,
      default: function () {
        return {};
      }
    },
    tableParams: {
      type: Object,
      default: function () {
        return {};
      }
    },
    formValue: {
      type: Object,
      default: function () {
        return {};
      }
    },
    applicationId: {
      type: String
    },
    id: {
      type: String
    },
    linkId_appId: {
      type: String
    },
    unitFilter: {
      type: Boolean,
      default: false
    },
    deptFilter: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      serviceId: "",
      menuItems: [],
      defaultKey: '',
      $viewObj: undefined,
      openFormEditMode:false,
      treeNodeFields:[]
    };
  },
  mounted() {
    let me = this;
    if (me.id) {
      me.renderById([me.id]);
    }
    if (me.linkId_appId) {
      me._renderByLinkId();
    }
  },
  watch: {
    'id': function (val, oldVal) {
      if(val){
        this.renderById([val]);
      }
    },
    'linkId_appId': function (val, oldVal) {
      if(val){
        this._renderByLinkId();
      }
    }
  },

  beforeDestroy() {
    this._destroyViewObj();
  },
  methods: {

    _handleSelect(v) {
      this.renderById([v]);
    },
    _renderByLinkId() {
      let me = this;
      let p = me.linkId_appId.split("_");
      me.menuItems = [];
      me.mwApi.app.getNavigatorRecord(p[0], p[1]).then((data) => {
        let res = data.result;
        let targetIds = res.targetId.split(',');
        let targets = res.target.split(',');
        for (let i = 0; i < targetIds.length; i++) {
          me.menuItems.push({id: targetIds[i], name: targets[i]});
        }
        me.defaultKey = targetIds[0];
        me.renderById([me.defaultKey]);
      });
    },
    _destroyViewObj() {
      try {
        if (this.$viewObj)
          this.$viewObj.$destroy();
        this.$viewObj = undefined;
      } catch (e) {
      }
    },

    getCurrentSelection() {
      return this.$viewObj.getCurrentSelection();
    },

    refresh() {
      if(!this.$viewObj) return;
      return this.$viewObj.refresh()
    },

    /**
     * 获取树选择记录
     */
    getTreeSelection() {
      return this.$viewObj.getTreeSelection();
    },


    renderById($$$ids) {
      let $$$me = this;
      if (!$$$ids) {
        return
      }
      let vp = _.clone($$$me.params);
      delete vp.getForm;
      delete vp.config;
      $$$me.mwApi.app.getApplicationViewItems($$$ids, vp,"").then(($$$data) => {

        let $$$el = $$$me.$el.querySelector('.mw-page-view__config')
        $($$$el).empty();
        $$$me._destroyViewObj();

        $$$me.serviceId = $$$ids[0];
        if (!$$$data.result[0]) {
          $$$me.mwMsg('info', '视图不存在或未配置完整！');
          return;
        }
        let $$$content = $$$data.result[0].content;
        if(!$$$content) return;
        let $$$colLength = $$$content.columns.length;
        let $$$html = '';
        for (let i = 0; i < $$$colLength; i++) {
          var v = $$$content.columns[i];
          if(v.colHtml){
            if(!v.prop){
              v.prop=$uuid();
            }
            $$$html += `<template slot="${v.prop}" slot-scope="scope">
              ${v.colHtml}
            </template>`;
          }
        }

        let template=`<div class="mw-page-view__config mw-panel">
        <toolbar-table ref="toolbarTable" :applicationId="applicationId" :layout="layout" :treeExpandFirst="autoExpandFirst">
        ${$$$html}
        </toolbar-table></div>`;

        $$$me.$viewObj = PF.createVue({
          el: $$$el,
          template: template,
          data: {
            extTableParams: $$$me.tableParams,
            extParent:$$$me,
            extCustomCondition: undefined,
            viewConfig: undefined,
            serviceId: $$$me.serviceId,
            mixId: '',
            layout: [],
            applicationId: $$$me.applicationId,
            moduleId: '',
            formId: '',
            defaultKey: $$$me.defaultKey,
            deptFilter: $$$me.deptFilter,
            unitFilter: $$$me.unitFilter,
            formValue: $$$me.formValue,
            params: $$$me.params,
            beforeOpenFormFn:null,
            autoExpandFirst:!$$$content.tree || $$$content.tree.autoExpandFirst!==false
          },
          computed: {
            ...mapGetters([
              'curSelUnitId',
              'curSelDeptId'
            ])
          },
          store: store,
          router: mwRouter,
          created() {
          },
          beforeDestroy() {
          },
          mounted() {
            let $me = this;
            $me.viewConfig = $$$content;

            let $script = `(0,function(me){

            ` + $$$content.javascript + `
              return function(exp){
                  return eval("(0,"+exp+")");
              }
            })`;

            if ($$$content.table.moduleId) {
              $me.mixId = $$$content.table.moduleId;
              $me.moduleId = $$$content.table.moduleId;
            } else {
              if ($$$content.table.moduleId) {
                $me.mixId = $$$content.table.moduleId;
                $me.moduleId = $$$content.table.moduleId;
              }
            }
            if ($$$content.table.formId) {
              $me.formId = $$$content.table.formId;
              //$me.mixId=$me.mixId+'_'+$me.formId;
            }
            let $$$defaultSort = [];
            $$$content.columns.forEach(v => {
              if (v.way && v.way == '2') {
                v.formatter = $me._titleFormatter
              }
              if (v.sort) {
                v.sortable = "custom";
                if(["desc","asc"].indexOf(v.sort) != -1){
                   $$$defaultSort.push({sort: v.prop, dir: v.sort});
                }
              }
            })
            let $$$url = '#data.listDocData';
            if ($$$content.table.way == '1') {
              $$$url = $$$url.substring(1);
            } else if ($$$content.table.way == '2') {
              let url = $$$content.table.url;
              if (!url) {
                $me.mwMsg('warning', '请配置表格属性URL');
                return
              }
              if (url.indexOf('.') > -1) {
                if (url.startsWith("#")) { //平台后台服务 #app.listSystemService
                  $$$url = url.substring(1);
                } else {
                  $$$url = "/" + url;   //公用
                  /*if(url.indexOf('?')>-1){
                    $$$url='cheetah/service/'+url+'$$forceTran=false'
                  }else{
                    $$$url='cheetah/service/'+url+'?$$forceTran=false'
                  }*/
                }
              } else {
                $$$url = "#" + $$$ids[0] + '.' + url;  //视图内部
                /*if(url.indexOf('?')>-1) {
                  $$$url = 'cheetah/service/' + $$$ids[0] + '.' + url + '$$es=true&$$forceTran=false'
                }else{
                  $$$url = 'cheetah/service/' + $$$ids[0] + '.' + url + '?$$es=true&$$forceTran=false'
                }*/
              }
            }

            let scriptEval;
            try {
              scriptEval = eval($script);
            } catch (e) {
              if(window.console)console.log(e);
              return alert("视图脚本错误:" + e.getMessage())
            }
            scriptEval = scriptEval.call($me, $me);
            let contextEval = function (exp) {
              let fn;
              try {
                fn = scriptEval(exp);
              } catch (e) {
                if(window.console)console.log('-_-" 函数' + exp + '配置错误了')
              }
              return (typeof fn === "function") ? fn : undefined;
            }
            $me.$contextEval = contextEval;
            let $$$items = [];
            $$$colLength = $$$content.columns.length;
            for (let i = 0; i < $$$colLength; i++) {
              var v = $$$content.columns[i];
              if (v.prop && v.colHtml) {
                v.slotName = v.prop
              } else {
                if (v.way && v.way == '3') {
                  if (v.openFunc) {
                    if (typeof(v.openFunc) === 'string' && v.openFunc !== "") {
                      v.openFunc = contextEval(v.openFunc);
                    }
                  }
                  v.slot = {type: 'html', scope: $me, func: v.openFunc, html: "{{ scope.row[item.prop]}}"};
                }
                if(v.clickEdit && $$$me.params.formeditform !== false){
                  v.slot={type:"editableInput",func:v.openFunc}
                }
                if (v.formatter) {
                  if (typeof(v.formatter) === 'string' && v.formatter !== "") {
                    v.formatter = contextEval(v.formatter);
                  }
                }
              }
              $$$items.push(v);
            }
            $$$me.mwLodash.remove($$$content.columns, "hidden")
            $$$colLength = $$$content.treeToolbarItem.length;
            for (var i = 0; i < $$$colLength; i++) {
              var v = $$$content.treeToolbarItem[i];
              if (typeof(v.func ) === 'string' && v.func !== "") {
                v.func = contextEval(v.func);
                v.$scope = $me;
              }
            }
            if($me.viewConfig.table.unitFilter){
              $me.unitFilter = $me.viewConfig.table.unitFilter;
            }
            let pageLimit  = $$$content.table.pageLimit;
            if(pageLimit){
              pageLimit = parseInt(pageLimit);
            }
            var singleSelect =  $$$me.params.multiple===false ? true : !$$$content.table.multiple;
            $$$items.push({
              key: $uuid(),
              type: 'menu',
              label: '',
              unitFilter: $me.unitFilter,
              deptFilter: $me.deptFilter,
              pagination: $$$content.table.pagination,
              noPaginationLimit: $$$content.table.noPaginationLimit,
              toolbar: $$$content.table.toolbar,
              defaultActive: true,
              singleSelect: singleSelect,
              showRowExpander:$$$content.table.showRowExpander,
              customCondition: $$$content.table.condition,
              extCustomCondition: $me.extCustomCondition,
              defaultPercent: $$$content.table.treePercent,
              treeToolbarItem: $$$content.treeToolbarItem,
              readerAuthorize: $$$content.table.auth,
              treeConfig: $me._parseTreeConfig($$$content.tree, $$$ids[0], $$$content.table),
              toolbarItem: $$$content.toolbarItem,
              api: $$$url,
              defaultParams: $me.mwLodash.assign({mixId: $me.mixId,limit:pageLimit}, {condition: $me.extTableParams}),
              defaultSort: $$$defaultSort,
              columns: $$$content.columns
            });
            var $$$length = $$$content.toolbarItem.length;
            for (var i = 0; i < $$$length; i++) {
              var v = $$$content.toolbarItem[i];
              if (v.type == 'button') {
                for (var j = 0; j < v.items.length; j++) {
                  var v1 = v.items[j];
                  if (typeof(v1.func ) === 'string' && v1.func !== "") {
                    v1.func = contextEval(v1.func);
                    v1.$scope = $me;
                  }
                }
              }
              if (v.type == 'searchText') {
                var searchText = $$$content.searchText;
                if (searchText) {
                 /* if (searchText.prop)
                    v.name = searchText.prop*/
                  if (searchText.tip)
                    v.tip = searchText.tip
                  if(searchText.searchCurNode)
                    v.searchCurNode = searchText.searchCurNode;
                  var searchCol=[];
                  $$$content.columns.forEach(v=>{
                    if(v.search && v.prop){
                      searchCol.push(v.prop);
                    }
                  })
                  if(searchCol.length>0){
                    v.name=searchCol.join("|");
                  }else{
                    v.name = 'title'
                  }
                } else {
                  v.name = 'title'
                }
              }
              $$$items.push(v);
            }
            $me.layout = [];
            $me.layout.push($$$items);
            $me.getDataTable().$on("dataLoaded",function(dataList){
              $me.$emit("dataLoaded", dataList);
            });
            $me.getDataTable().$on("rowClick",function(row, event, column){
              $me.$emit("rowClick", row, column,event);
            });
            $me.getDataTable().$on("row-dblclick",function(row, event){
              $me.$emit("row-dblclick", row, event);
            });
            $me.getDataTable().$on("selectChange",function(selection){
              $me.$emit("selectChange",selection);
            });
            $me.getDataTable().$on("rowExpanded",function(row,container){
              $me.$emit("rowExpanded",row,container);
            });

            $$$me.$emit("ready",$me);
          },
          methods: {
            exe(a, ...args) {
              let func = this.$contextEval(a);
              if(!func)return;
              return func.apply(this,args);
            },
            invoke(url, ...args) {
              return PF.invokeInner(this.serviceId + '.' + url, ...args);
            },
            getCurrentSelection() {
              let me = this;
              let selData = me.mwRef('toolbarTable').getMultipleSelection();
              let ret = _.clone(selData);
              me.mwRef('toolbarTable').$emit("selData",ret);
              return ret;
            },
            getDataTable:function(){
              return this.$refs.toolbarTable.$refs.dataTable;
            },
            getData:function(){
              return this.getDataTable().getData();
            },
            _titleFormatter(a, b, c) {
              let me = this;
              return (<span class={{'link': true}} title={c}onClick={(event) => me._showForm(a, event)}>{c ? c : '无标题'}</span>)
            },

            refresh() {
              this.mwRef('toolbarTable').refreshTable()
            },

            /**
             * 获取树选择记录
             */
            getTreeSelection() {
              let tree = this.mwRef('toolbarTable').mwRef('tree');
              if (tree) {
                return tree.getSelected();
              }
              return undefined;
            },

            _parseTreeConfig(data, id, table) {
              let me = this;
              let config = {dragEnable:data.dragEnable};
              let treeConfig = data.treeData;
              if (table.treePercent == 0) {
                return;
              }
              if (data.way == '1') { //单表
                config.url = this.mwUrl("/api/data/listDocTree");
              } else {
                let url = data.url;
                if (!url) {
                  me.mwMsg('warning', '请配置树属性URL');
                  return
                }
                if (url.indexOf('.') > -1) {
                  if (url.startsWith("#")) {
                    config.url = this.mwUrl(url.substring(1));
                  } else {
                    if (url.indexOf('?') > -1) {
                      config.url = this.mwUrl('/cheetah/service/') + url + '$$forceTran=false'
                    } else {
                      config.url = this.mwUrl('/cheetah/service/') + url + '?$$forceTran=false'
                    }
                  }
                } else {
                  if (url.startsWith("#")) {
                    config.url = this.mwUrl(url.substring(1));
                  } else {
                    config.url = this.mwUrl('/cheetah/service/') + id + '.' + url + '?$$es=true&$$forceTran=false'
                  }
                }
              }
              config.paramsAnalyze = function (node, tree) {
                let params = {};
                let parentLen = node.parents.length
                let con = treeConfig[parentLen];
                if (con == undefined) {
                  con = me._getFiledContent(parentLen, treeConfig);
                }
                params.field = con.name;
                params.moduleId = data.moduleId;
                let sort=con.sortWay;
                if(!sort){
                  sort='asc'
                }
                if(me.extTableParams){
                  params = _.assign(params,me.extTableParams);
                }
                params.orderBy = (con.sortName ? con.sortName : con.name) + ' ' + sort;
                params.levelCur = parentLen + 1;
                params.levelCount = treeConfig.length;
                params.blank = con.blank ? con.blank : '';

                if (me.applicationId) {
                  params.applicationId = me.applicationId;
                }

                if (data.condition)
                  params.customCondition = data.condition;

                if (me.extCustomCondition)
                  params.extCustomCondition = me.extCustomCondition;

                if (me.unitFilter) {
                  if (me.curSelUnitId) {
                    params.unitFilter = me.curSelUnitId
                  }
                }
                if (me.deptFilter) {
                  if (me.curSelDeptId) {
                    params.deptFilter = me.curSelDeptId
                  }
                }
                params.readerAuthorize=table.auth
                me._addParams(params, node, tree, treeConfig)
                me.$emit("beforeTreeLoad",params,node,tree,treeConfig);
                return params;
              }
              config.changed = function (v, tree) {
                let params = {};
                if(me.extTableParams)
                  params = _.assign(params,me.extTableParams);
                let node = tree.getNode(v.id);
                me._addTableParams(params, node, tree, treeConfig);
                let toolbarTable = me.mwRef('toolbarTable');
                if(!me.treeNodeFields || me.treeNodeFields.length===0){
                  if(!me.treeNodeFields) me.treeNodeFields = [];
                  for(var k in params){
                    me.treeNodeFields.push(k);
                  }
                  toolbarTable.treeNodeFields = me.treeNodeFields;
                }
                toolbarTable.isSearch = false;
                //toolbarTable.clearFilters();
                if(toolbarTable.mwRef('dataTable')) {
                  let defaultParams = toolbarTable.mwRef('dataTable').defaultParams
                  let newDefaultParams = Object.assign({}, defaultParams, {condition: params});
                  me.$emit("treeSelectionChange",newDefaultParams,node);
                  if(newDefaultParams.returnFalse){
                    return;
                  }
                  toolbarTable.allowLoaded=true;
                  toolbarTable.refreshTableDefaultParams(newDefaultParams);
                }
              }
              return config;
            },

            _getFiledContent(parentLen, treeConfig) {
              parentLen = parentLen - 1;
              if (parentLen == -1) {
                return;
              }
              if (treeConfig[parentLen] != null) {
                return treeConfig[parentLen];
              } else {
                return this._getFiledContent(parentLen, treeConfig);
              }
            },

            _addTableParams(params, node, tree, treeConfig) {
              let parentLen = node.parents.length
              if (node.parent) {
                let con = treeConfig[parentLen - 1];
                if (con) {
                  let param = _.trim(con.tableParamName);
                  let field = _.trim(con.tableParamField);
                  if (con.blank) {
                    if (con.blank == node.text) {
                      if (param.length == 0) {
                        params[con.name] = 'valueIsNull'
                      } else {
                        params[param] = 'valueIsNull';
                      }
                    } else {
                      if (param.length == 0) {
                        params[con.name] = node.text
                      } else {
                        if (field.length == 0)
                          params[param] = node.original[param];
                        else
                          params[param] = node.original[field];
                      }
                    }
                  } else {
                    if (param.length == 0) {
                      params[con.name] = node.text
                    } else {
                      if (field.length == 0)
                        params[param] = node.original[param];
                      else
                        params[param] = node.original[field];
                    }
                  }
                  this._addTableParams(params, tree.getNode(node.parent), tree, treeConfig);
                } else {
                  this._getConName(params, node, tree, parentLen, treeConfig);
                }
              }
            },
            _getConName(params, node, tree, length, treeConfig) {
              let con = treeConfig[length - 1];
              if (con) {
                let name = con.name;
                let param = _.trim(con.tableParamName);
                let field = _.trim(con.tableParamField);
                if (param.length == 0) {
                  params[name] = node.original[name];
                } else {
                  if (field.length == 0)
                    params[param] = node.original[param];
                  else
                    params[param] = node.original[field];
                }
              } else {
                length = length - 1;
                if (length < 0) {
                  return;
                }
                if (treeConfig.length > 1) {
                  this._getConName(params, tree.getNode(node.parent), tree, length, treeConfig);
                } else {
                  this._getConName(params, node, tree, length, treeConfig);
                }
              }
            },
            _addParams(params, node, tree, treeConfig, pnode) {
              let parentLen = node.parents.length;
              if (node.parent) {
                let con = treeConfig[parentLen - 1];
                if (!con) {
                  this._addParams(params, tree.getNode(node.parent), tree, treeConfig, pnode || node);
                  return;
                }
                let param = _.trim(con.treeParamName);
                let field = _.trim(con.treeParamField);
                let vNode = pnode || node;
                if (con.blank) {
                  if (con.blank == vNode.text) {
                    if (param.length == 0) {
                      params['&' + con.name] = 'valueIsNull';
                    } else {
                      params['&' + param] = 'valueIsNull';
                    }
                    this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                  } else {
                    if (param.length == 0) {
                      params['&' + con.name] = vNode.text;
                      this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                    } else {
                      if (treeConfig.length == 1) { //只有一级
                        if (field.length == 0)
                          params[param] = vNode.original[param];
                        else
                          params[param] = vNode.original[field];
                      } else {
                        if (field.length == 0)
                          params['&' + param] = vNode.original[param];
                        else
                          params['&' + param] = vNode.original[field];
                        this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                      }
                    }
                  }
                } else {
                  if (param.length == 0) {
                    params['&' + con.name] = vNode.text;
                    this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                  } else {
                    if (treeConfig.length == 1) { //只有一级
                      if (field.length == 0)
                        params[param] = vNode.original[param];
                      else
                        params[param] = vNode.original[field];
                    } else {
                      if (field.length == 0)
                        params['&' + param] = vNode.original[param];
                      else
                        params['&' + param] = vNode.original[field];
                      this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                    }
                  }
                }
              }
            },
            _openAll() {
              this.mwRef('toolbarTable').mwRef('tree').openAll();
            },
            _closeAll() {
              this.mwRef('toolbarTable').mwRef('tree').closeAll();
            },
            _AddFormData() {
              //event.stopPropagation();
              let me = this;
              let p = {};
              p.moduleId = me.mixId;
              p.size = 'large_large'
              p.appId = '';
              p.editMode = true;
              p.type = 'normal'
              if (me.formValue)
                p.initValue = me.formValue;

              let extParams = {
                "$view": me
              };
              if (me.unitFilter) {
                if (me.curSelUnitId) {
                  extParams.unitFilter = me.curSelUnitId
                }
              }
              if (me.deptFilter) {
                if (me.curSelDeptId) {
                  extParams.deptFilter = me.curSelDeptId;
                }
              }

              p.extParams = extParams

              PF.show('normalForm', p, function () {
                me.refresh()
              }, function (updateData) {
                if (updateData) {
                  me.refresh()
                }
              });
            },
            _changeFormVersion(a, b, c) {
              if (a.length == 0) {
                b.mwMsg('warning', $lang('请选择需要切换的记录'));
                return;
              }
              let ids = [];
              a.forEach(t => {
                ids.push(t.id);
              });

              PF.show('changeFormVersion', {moduleId: this.mixId, ids: ids});
            },
            _deleteFormData(a, b, c) {
              let me = this;
              if (a.length == 0) {
                b.mwMsg('warning', $lang('请选择需要删除的记录'));
                return;
              }
              let businessIds = [];
              a.forEach(t => {
                businessIds.push(t.id);
              });
              b.mwConfirm($lang('此操作执行之后将无法恢复，请谨慎操作！您确定彻底删除选中的记录吗？'), $lang('提示'), {
                type: 'warning'
              }).then(() => {
                let params = {};
                params.idList = businessIds;
                params.formId = me.formId;
                params.moduleId = me.moduleId;
                b.mwApi.data.deleteFormData(params).then(res => {
                  if (res.success) {
                    b.refreshTable();
                  }
                });
              }).catch(() => {

              });
            },
            //标记删除流程数据和表单数据 initMarkStatus: 0-正常  2-标记删除  可在回收站中找回
            _markDeleteFormData(a, b, c) {
              let me = this;
              if (a.length == 0) {
                b.mwMsg('info', $lang('请选择需要标记删除的记录'));
                return;
              }
              let businessIds = [];
              a.forEach(t => {
                businessIds.push(t.id);
              });
              b.mwConfirm($lang('您确定标记删除选中的记录吗？'), $lang('提示'), {
                type: 'warning'
              }).then(() => {
                let params = {};
                params.idList = businessIds;
                params.formId = me.formId;
                params.moduleId = me.moduleId;
                b.mwApi.data.markDeleteFormData(params).then(res => {
                  if (res.success) {
                    b.refreshTable();
                  }
                });
              }).catch(() => {
              });
            },
            _markDeleteFormDataReleaseWH(a, b){
              let me = this;
              if (a.length == 0) {
                b.mwMsg('info', $lang('请选择需要标记删除的记录'));
                return;
              }
              let businessIds = [];
              a.forEach(t => {
                businessIds.push(t.id);
              });
              b.mwConfirm($lang('您确定标记删除选中的记录吗？'), $lang('提示'), {
                type: 'warning'
              }).then(() => {
                let params = {};
                params.idList = businessIds;
                params.formId = me.formId;
                params.moduleId = me.moduleId;
                b.mwApi.data.markDeleteFormDataReleaseWH(params).then(res => {
                  if (res.success) {
                    b.refreshTable();
                  }
                });
              }).catch(() => {
              });
            },
            //还原被标记删除流程数据和表单数据
            _restoreDeletedFormData(a, b, c) {
              let me = this;
              if (a.length == 0) {
                b.mwMsg('info', $lang('请选择需要还原的记录'));
                return;
              }
              let businessIds = [];
              a.forEach(t => {
                businessIds.push(t.id);
              });
              b.mwConfirm($lang('您确定还原选中的记录吗？'), $lang('提示'), {
                type: 'warning'
              }).then(() => {
                let params = {};
                params.idList = businessIds;
                params.formId = me.formId;
                params.moduleId = me.moduleId;
                b.mwApi.data.restoreDeletedFormData(params).then(res => {
                  if (res.success) {
                    b.refreshTable();
                  }
                });
              }).catch(() => {

              });
            },
            _showForm(row, event) {
              event.stopPropagation();
              let me = this;
              let p = {};
              p.businessId = row.id;
              p.moduleId = me.mixId;
              if(row.initbatchid){
                p.batchId=row.initbatchid;
              }else{
                p.batchId=row.id;
              }
              p.processDefinitionId=row.initprocdefid;
              p.size = 'large_large'
              p.type = 'normal'
              p.editMode = me.openFormEditMode || false;
              p.appId = '';
              let extParams = {
                "$view": me
              };
              if (me.unitFilter) {
                if (me.curSelUnitId) {
                  extParams.unitFilter = me.curSelUnitId
                }
              }
              if (me.deptFilter) {
                if (me.curSelDeptId) {
                  extParams.deptFilter = me.curSelDeptId;
                }
              }

              p.extParams = extParams
              if($.isFunction(me.beforeOpenFormFn)){
                me.beforeOpenFormFn(p);
              }
              PF.show('normalForm', p, function () {
                me.refresh()
              }, function (updateData) {
                if (updateData) {
                  me.refresh()
                }
              });
            },
          }
        })
      })


    },

  }
}



// WEBPACK FOOTER //
// ./src/common/components/extend/view/index.js